var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"breadcrumb-item"},[(_vm.item.href)?_c('nuxt-link',{attrs:{"to":_vm.item.href}},[_vm._v(_vm._s(_vm.item.text))]):_c('a',[_vm._v(_vm._s(_vm.item.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }